import axios from "axios";

export const GET_PROJECTS_LEVELS = "cms/project/levels/";

export function getProjectsLevels(params) {
  return axios.get(GET_PROJECTS_LEVELS, params);
}
